import { useInfiniteQuery, } from '../../lib/useInfiniteQuery';
import { useTribeClient } from '../../useTribeClient';
import { getSpacesKey } from '../../utils/keys';
export const useMemberSpaces = (options) => {
    const { variables, fields = { space: 'basic', member: 'basic', role: 'basic' }, useInfiniteQueryOptions, } = options || {};
    const { client } = useTribeClient();
    const spacesKey = getSpacesKey(variables);
    return useInfiniteQuery(spacesKey, ({ pageParam: after }) => client === null || client === void 0 ? void 0 : client.spaceMembers.listSpaces({ after, ...variables }, fields), useInfiniteQueryOptions);
};
//# sourceMappingURL=useMemberSpaces.js.map